const gaTrackers = {};

class Analytics {

  ids = process.env.NODE_ENV === 'production' && ['UA-806038-4'] || [];

  initialize(analyticsCode = ''){
    const googleAnalyticsId = analyticsCode.split(/[\s,]+/).filter(y => !!y);
    this.ids = [...this.ids, ...googleAnalyticsId];
    for (let i = 0; i < this.ids.length; i++) {
      if (!gaTrackers[this.ids[i]]) {
          gaTrackers[this.ids[i]] = true;
          gtag('config', this.ids[i])
      }
    }
  }

  pageview(){
    gtag('event', 'page_view')
  }

  viewitem(data){
    gtag('event', 'view_item', {items: [data]})
  }

  checkout(data){
    gtag('event', 'begin_checkout', {items: [data]})
  }

  ecAddItem(data){
    gtag('event', 'add_to_cart', {items: [data]})
  }

  ecAddTransaction(data){
    gtag('event', 'purchase', data)
  }

  event(...data){
    const [id, category, label] = data;
    gtag('event', id, {
      'event_category': category,
      'event_label': label
    })
  }
}

export default new Analytics();



// WEBPACK FOOTER //
// ./src/js/helpers/universalAnalytics.js